<template>
  <div>
    <div class="columns dontprint">
      <div class="column">
        <h1 class="title is-5">Comisiones</h1>
      </div>
    </div>
    <div class="columns dontprint">
      <div class="column is-3">
        <div class="control">
          <div class="select">
            <select v-model="comprobanteingreso" @change="updateempresa">
              <option
                v-for="(item, index) in options"
                :key="index"
                :value="item._id"
              >
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="control">
          <div class="select">
            <select v-model="comprobantefactura" @change="updateempresa">
              <option
                v-for="(item, index) in options2"
                :key="index"
                :value="item._id"
              >
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="control">
          <div class="select">
            <select v-model="cuentadescuento" @change="updateempresa">
              <option :value="null">Cuenta Descuento</option>
              <option
                v-for="(item, index) in cuentas"
                :key="index"
                :value="item._id"
              >
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="control">
          <div class="select">
            <select v-model="selectedVendor" @change="filterVendor">
              <option :value="null">Vendedor</option>
              <option
                v-for="(item, index) in vendedores"
                :key="index"
                :value="item._id"
              >
                {{ item.codigo | textnumber() }} - {{ item.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="columns dontprint">
      <div class="column is-9">
        <y-periodselector
          @period="periodselected"
          :iscierre="false"
          :period="period"
        ></y-periodselector>
      </div>
      <div class="column is-3">
        <div class="buttons has-addons is-right">
          <button class="button is-primary" @click="downloadReport">
            <span>Descargar</span>
          </button>
          <button class="button is-light" @click="print">Imprimir</button>
        </div>
      </div>
    </div>
    <div class="columns printed">
      <div class="column">
        <h1 class="title is-4">
          {{ empresa.nombre }}
          <small class="has-text-grey"
            >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
          >
        </h1>
        <h2 class="subtitle">
          Comisiones {{ nameMonth[period.months[0]] }} de
          {{ period.year }}
        </h2>
      </div>
    </div>
    <table class="table is-narrow is-fullwidth">
      <thead>
        <tr>
          <td>Vendedor</td>
          <td>Cliente</td>
          <td>Factura</td>
          <td>RC</td>
          <td>Abono</td>
          <td>Base</td>
          <td>Días</td>
          <td>% Edad</td>
          <td>% Cliente</td>
          <td>% Vendedor</td>
          <td>% Producto</td>
          <td>Comision</td>
        </tr>
      </thead>
      <tbody
        v-for="(item, index) in comisiones.listvendedoresfiltered"
        :key="index"
      >
        <tr>
          <td colspan="2">
            <strong>
              {{ datavendedores[item].nombre }}
              <small>{{ datavendedores[item].codigo | textnumber() }}</small>
            </strong>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr
          v-for="(item1, index1) in comisiones[item].listabonos"
          :key="index1"
        >
          <td></td>
          <td>
            <small
              >{{ nitsfilter[item1.idnit].nombre }}
              {{ nitsfilter[item1.idnit].codigo | textnumber() }}</small
            >
          </td>
          <td class="fontMono has-text-right">
            {{ item1.docRef }}
          </td>
          <td class="fontMono has-text-right">{{ item1.documento }}</td>
          <td class="fontMono has-text-right">
            {{ item1.valor | number() }}
          </td>
          <td class="fontMono has-text-right">
            {{ item1.base | number() }}
          </td>
          <td class="fontMono has-text-right">
            {{ item1.dias }}
          </td>
          <td class="fontMono has-text-right">{{ item1.pedad }}%</td>
          <td class="fontMono has-text-right">{{ item1.pcliente }}%</td>
          <td class="fontMono has-text-right">{{ item1.pvendedor }}%</td>
          <td
            class="fontMono has-text-right"
            :class="!item1.isvalidnomenclatura ? 'has-text-danger' : ''"
          >
            {{ item1.pproducto }}%
          </td>
          <td class="fontMono has-text-right">
            {{ item1.comision | number() }}
          </td>
        </tr>
        <tr style="background-color: #f5f5f5">
          <td colspan="2">
            <strong>Total {{ datavendedores[item].nombre }}</strong>
          </td>
          <td></td>
          <td></td>
          <td class="fontMono has-text-right">
            <strong>{{ comisiones[item].abono | number() }}</strong>
          </td>
          <td class="fontMono has-text-right">
            <strong>{{ comisiones[item].base | number() }}</strong>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="fontMono has-text-right">
            <strong>{{ comisiones[item].comision | number() }}</strong>
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="has-text-white dontprint">0</td>
        </tr>
      </tbody>
      <tbody v-show="!selectedVendor">
        <tr style="background-color: #3273dc">
          <td><strong class="has-text-white">Total</strong></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="fontMono has-text-right">
            <strong class="has-text-white">
              {{ comisiones.resumen ? comisiones.resumen.abono : 0 | number() }}
            </strong>
          </td>
          <td class="fontMono has-text-right">
            <strong class="has-text-white">
              {{ comisiones.resumen ? comisiones.resumen.base : 0 | number() }}
            </strong>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="fontMono has-text-right">
            <strong class="has-text-white">
              {{
                comisiones.resumen ? comisiones.resumen.comision : 0 | number()
              }}
            </strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import yPeriodselector from "@/components/commons/PeriodselectorV2.vue";
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
export default {
  data() {
    return {
      nameMonth: {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre",
      },
      dataserver: [],
      selectedVendor: null,
      comprobanteingreso: null,
      comprobantefactura: null,
      cuentadescuento: null,
      period: {
        year: null,
        months: null,
      },
      comisiones: {},
      options: [],
      options2: [],
      edades: [],
      vendedores: [],
      datavendedores: {},
      clientes: {},
      nitsfilter: {
        list: [],
      },
    };
  },
  computed: {
    ...mapState(["cuentas", "nits", "empresa", "isOculto"]),
  },
  methods: {
    print() {
      const _this = this;
      if (this.isOculto) {
        this.$store.commit("ocultarSide");
        setTimeout(() => {
          window.print();
          _this.$store.commit("ocultarSide");
        }, 200);
      } else {
        window.print();
      }
    },
    filterVendor() {
      this.comisiones = this.transformdata(this.dataserver);
    },
    async downloadReport() {
      try {
        let result;
        result = await apiServices.post(`/downcomisiones`, this.period, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Comisiones.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.log(err);
      }
    },
    calculatedays(d1, d2) {
      let diff;
      if (d1 !== 0 && d2 !== 0) {
        let dt1 = new Date(d2).getTime();
        let dt = new Date(d1).getTime();
        diff = dt1 - dt;
        diff = diff / (1000 * 60 * 60 * 24);
        diff--;
      } else {
        diff = 0;
      }
      return parseInt(diff);
    },
    async updateempresa() {
      try {
        const empresa = JSON.parse(JSON.stringify(this.empresa));
        empresa.comprobanteingreso = this.comprobanteingreso;
        empresa.comprobantefactura = this.comprobantefactura;
        empresa.cuentadescuento = this.cuentadescuento;
        const result = await apiServices.post(`/editempresa`, empresa);
        if (result.data) {
          this.$store.commit("refreshEmpresa", result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async traeComprobantes() {
      try {
        const _this = this;
        const result = await apiServices.get(`/comprobantes`);
        this.options = [];
        this.options2 = [];
        this.options.push({
          _id: null,
          codigo: "Seleccionar",
          nombre: "Ingreso",
        });
        this.options2.push({
          _id: null,
          codigo: "Seleccionar",
          nombre: "Factura",
        });
        for (let index in result.data) {
          const dato = result.data[index];
          _this.options.push(dato);
          _this.options2.push(dato);
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un problema cargando los comprobantes.",
          type: "is-danger",
          position: "top-center",
        });
        console.log("ocurrio un problema cargando los comprobantes", err);
      }
    },
    periodselected(period) {
      this.period = period;
    },
    datotercero(idtercero) {
      return this.nits.filter((nit) => nit._id === idtercero)[0];
    },
    porcentajeproducto(dato) {
      let returned = 100;
      if (dato.datosfactura.listgrupo.length === 1) {
        returned = dato.datosfactura.listgrupo1[0].percent;
      }
      return returned;
    },
    nombregrupo(dato) {
      let returned = "N/A";
      if (dato.datosfactura.listgrupo.length === 1) {
        returned = dato.datosfactura.listgrupo1[0].grupo;
      }
      return returned;
    },
    isvalidnomenclatura(dato) {
      let returned = 100;
      if (dato.datosfactura.listgrupo.length === 1) {
        returned = true;
      } else {
        returned = false;
      }
      return returned;
    },
    porcentajeEdad(dias, dato) {
      const fpago = dato.datosfactura ? parseInt(dato.datosfactura.fpago) : 0;
      const dias1 = dias - fpago;
      const _this = this;
      let returned = 0;
      for (let index = 0; index < this.edades.length; index++) {
        if (dias1 <= _this.edades[index].dias) {
          returned = _this.edades[index].porcentaje;
          break;
        }
      }
      return returned;
    },

    transformdata(data) {
      const duplicatedata = [];
      const _this = this;
      function porcentajeCliente(idcliente, idvendedor, dato) {
        let returned = 100;
        if (_this.clientes[idcliente]) {
          returned = _this.clientes[idcliente].vendedores["all"].percentage;
          for (let index in _this.clientes[idcliente].vendedores.list) {
            const idvendedorc =
              _this.clientes[idcliente].vendedores.list[index];
            if (idvendedorc !== "all") {
              if (idvendedorc === idvendedor) {
                returned =
                  _this.clientes[idcliente].vendedores[idvendedorc].percentage;
              } else {
                const datoc = JSON.parse(JSON.stringify(dato));
                datoc.datosfactura.vendedor = idvendedorc;
                duplicatedata.push(datoc);
              }
            }
          }
        }
        return returned;
      }

      let resumen = {
        listvendedores: [],
        listvendedoresfiltered: [],
        resumen: {
          totaldebitocartera: 0,
          totalcreditocartera: 0,
          base: 0,
          abono: 0,
          listabonos: [],
          comision: 0,
        },
      };
      this.nitsfilter = {
        list: [],
      };

      function fordata(data) {
        for (let index in data) {
          const dato = data[index];
          if (dato.datosfactura && dato.datosfactura.vendedor) {
            dato.dias = _this.calculatedays(
              dato.datosfactura.fecha,
              dato.fecha
            );
            dato.pedad = _this.porcentajeEdad(dato.dias, dato);
            dato.pcliente = porcentajeCliente(
              dato.idnit,
              dato.datosfactura.vendedor,
              dato
            );
            dato.pvendedor = _this.datavendedores[dato.datosfactura.vendedor]
              ? _this.datavendedores[dato.datosfactura.vendedor].porcentaje
              : 100;

            dato.pproducto = _this.porcentajeproducto(dato);
            dato.isvalidnomenclatura = _this.isvalidnomenclatura(dato);
            dato.grupocomision = _this.nombregrupo(dato);
            dato.comision = 0;
            if (
              resumen.listvendedores.indexOf(dato.datosfactura.vendedor) === -1
            ) {
              resumen.listvendedores.push(dato.datosfactura.vendedor);
              resumen[dato.datosfactura.vendedor] = {
                listfacturas: [],
                totaldebitocartera: 0,
                totalcreditocartera: 0,
                base: 0,
                abono: 0,
                listabonos: [],
                comision: 0,
              };
            }
            const totaldato =
              dato.datosCartera.total > 0
                ? dato.datosCartera.total
                : -dato.datosCartera.total;
            dato.base =
              totaldato < 100
                ? dato.datosfactura.total - dato.datosCartera.descuento
                : 0;
            resumen[dato.datosfactura.vendedor].base += dato.base;
            resumen[dato.datosfactura.vendedor].listabonos.push(dato);
            resumen[dato.datosfactura.vendedor].abono += dato.valor;
            resumen.resumen.abono += dato.valor;
            resumen.resumen.base += dato.base;
            dato.comision =
              dato.base *
              (dato.pedad / 100) *
              (dato.pcliente / 100) *
              (dato.pproducto / 100) *
              (dato.pvendedor / 100);
            resumen[dato.datosfactura.vendedor].comision += dato.comision;
            resumen.resumen.comision += dato.comision;
            if (_this.nitsfilter.list.indexOf(dato.idnit) === -1) {
              _this.nitsfilter.list.push(dato.idnit);
              _this.nitsfilter[dato.idnit] = _this.datotercero(dato.idnit);
            }
          }
        }

        for (let index in resumen.listvendedores) {
          const vendedor = resumen.listvendedores[index];
          resumen[vendedor].listabonos.sort(
            (a, b) => parseInt(a.docRef) - parseInt(b.docRef)
          );
        }
        resumen.listvendedoresfiltered = [];
        if (
          _this.selectedVendor &&
          resumen.listvendedores.indexOf(_this.selectedVendor) !== -1
        ) {
          resumen.listvendedoresfiltered = [];
          resumen.listvendedoresfiltered.push(_this.selectedVendor);
        } else {
          resumen.listvendedoresfiltered = JSON.parse(
            JSON.stringify(resumen.listvendedores)
          );
        }
      }

      fordata(data);
      fordata(duplicatedata);
      for (let index in resumen.listvendedores) {
        const idvendedor = resumen.listvendedores[index];
        for (let index1 in resumen[idvendedor].listabonos) {
          const abonoAnterior = resumen[idvendedor].listabonos[index1 - 1];
          const abono = resumen[idvendedor].listabonos[index1];
          if (abonoAnterior && abonoAnterior.docRef === abono.docRef) {
            const copiabase = resumen[idvendedor].listabonos[index1 - 1].base;
            const copiacomision =
              resumen[idvendedor].listabonos[index1 - 1].comision;
            resumen[idvendedor].base -= copiabase;
            resumen[idvendedor].comision -= copiacomision;
            resumen.resumen.base -= copiabase;
            resumen.resumen.comision -= copiacomision;
            resumen[idvendedor].listabonos[index1 - 1].base = 0;
            resumen[idvendedor].listabonos[index1 - 1].comision = 0;
          }
        }
      }
      return resumen;
    },
    async findComisiones() {
      try {
        const result = await apiServices.post(`/comisiones`, this.period);
        if (result.data) {
          this.dataserver = result.data;
          this.comisiones = this.transformdata(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findEdades() {
      try {
        const result = await apiServices.get(`/getedades`);
        if (result.data) {
          this.edades = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findVendedores() {
      try {
        const _this = this;
        const result = await apiServices.get(`/getvendedores`);
        if (result.data) {
          this.vendedores = result.data;
          for (let index in result.data) {
            const vendedor = result.data[index];
            _this.datavendedores[vendedor._id] = vendedor;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findClientes() {
      try {
        const _this = this;
        const result = await apiServices.get(`/getclientes`);
        if (result.data) {
          this.clientes = {};
          for (let index in result.data) {
            const dato = result.data[index];
            const d = {
              _id: dato._id,
              idnit: dato.idnit,
              vendedores: dato.vendedores,
              descripcion: `${dato.idnit.codigo} - ${dato.idnit.nombre}`,
            };
            _this.clientes[dato.idnit._id] = d;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
    this.findComisiones();
    this.traeComprobantes();
    this.findEdades();
    this.findVendedores();
    this.findClientes();
    if (this.empresa.comprobanteingreso) {
      this.comprobanteingreso = this.empresa.comprobanteingreso;
    }
    if (this.empresa.comprobantefactura) {
      this.comprobantefactura = this.empresa.comprobantefactura;
    }
    if (this.empresa.cuentadescuento) {
      this.cuentadescuento = this.empresa.cuentadescuento;
    }
  },
  watch: {
    period(nv, ov) {
      this.findComisiones();
    },
  },
  components: {
    yPeriodselector,
  },
};
</script>

<style lang="scss" scoped>
@media print {
  .dontprint {
    display: none !important;
  }
  .printed {
    display: block !important;
  }
}
.printed {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/comisiones/Comisiones.vue